import React from 'react';
import PropTypes from 'prop-types';
import { content as ContentPropType } from 'lib/CustomPropTypes';
import AIMS_FLAVORS from 'lib/aimsFlavors';
import Tease from '../Tease';

function FeaturedTease({
  content, showUnibrow, block, headlineSizes, isRailAdjacent,
}) {
  return (
    <div className={block} data-test={block}>
      <Tease
        content={content}
        showInlineIcon={false}
        showUnibrow={showUnibrow}
        responsiveFlavors={{
          s: AIMS_FLAVORS.FOCAL_380x190,
          m: AIMS_FLAVORS.FOCAL_520x260,
          l: AIMS_FLAVORS.FOCAL_600x300,
          xl: AIMS_FLAVORS.FOCAL_560x280,
        }}
        headlineSizes={headlineSizes}
        isRailAdjacent={isRailAdjacent}
      />
    </div>
  );
}

FeaturedTease.propTypes = {
  content: ContentPropType.isRequired,
  showUnibrow: PropTypes.bool,
  isRailAdjacent: PropTypes.bool,
  block: PropTypes.string,
  headlineSizes: PropTypes.string,
};

FeaturedTease.defaultProps = {
  showUnibrow: false,
  isRailAdjacent: false,
  block: 'cover-spread-tease--featured',
  headlineSizes: 'f6 f7-m',
};

export default FeaturedTease;
